import { useMutation } from '@tanstack/react-query';

import { isFeatureEnabled } from '$shared/feature-toggle/is-feature-enabled';
import { fetcher } from '$shared/fetch';
import {
  DEVICE_SERVICE_EXPORT_PATH,
  MONITORING_BASE_PATH,
} from '$shared/utils/api-paths';

export interface MonitoringExportParameters {
  subject: string;
  name: string;
}

export interface MonitoringExportQueryParams {
  serialNumber: string;
  parameters: MonitoringExportParameters[] | [];
}

export interface EmailMonitoringExportQueryParams extends MonitoringExportQueryParams {
  startDate: string;
  endDate: string;
  exportPeriodName: string;
}

export const useEmailMonitoringExportWithQueryParams = () => {
  const isNewMonitoringExport = isFeatureEnabled(
    'ESEVNLS_4251_NEW_EXPORT_MONITORING_DATA',
  );

  const endpoint = isNewMonitoringExport
    ? `${DEVICE_SERVICE_EXPORT_PATH}/monitoring-data`
    : `${MONITORING_BASE_PATH}-email-export/actions/email-export-v2`;

  return useMutation({
    mutationFn: (params: EmailMonitoringExportQueryParams) =>
      fetcher.post(endpoint, params),
  });
};
